import { Table } from 'antd';
import { useParams } from 'react-router-dom';

import FileContextMenu from '../components/Files/FileContextMenu';
import FilesHeader from '../components/Files/FilesHeader';
import FilesList from '../components/Files/FilesList';
import FilesOnBehalfOfUserAlert from '../components/Files/FilesOnBehalfOfUserAlert';
import FilesTable from '../components/Files/FilesTable';
import FilesTableActionsCell from '../components/Files/FilesTableActionsCell';
import FilesTableDeletionDateCell from '../components/Files/FilesTableDeletionDateCell';
import FilesTableFileSizeCell from '../components/Files/FilesTableFileSizeCell';
import FilesTableTagsCell from '../components/Files/FilesTableTagsCell';
import FilesTableTitleCell from '../components/Files/FilesTableTitleCell';
import { FilesTableEnum } from '../enums/FilesTableEnum';
import useFiles from '../hooks/useFiles';
import type File from '../interfaces/File';
import ContentLayout from '../layouts/ContentLayout';

export const TrashFiles = () => {
  const params = useParams();

  const {
    files,
    isLoading,
    filters,
    handleFiltersChange,
    rowSelection,
    setSelectedTableKeys,
    handleRowContextMenu,
    handleTableChange,
    handleRowClick,
    handleLoadMore,
    selectedTableKeys,
    breadcrumbItems,
    isFilesListInGridMode,
    setIsFilesListInGridMode,
    isContextMenuVisible,
    setIsContextMenuVisible,
    contextMenuPosition,
    handleFileMenuAction,
    selectedFiles,
    handleFileRowClick,
    handleFileRowDoubleClick,
    emptyState,
    topBarFileActions,
    contextMenuFileActions,
    tableScrollY,
  } = useFiles({
    table: FilesTableEnum.Trash,
    folderUid: params?.folderUid,
  });

  return (
    <ContentLayout>
      <ContentLayout.Header>
        <FilesHeader
          isLoading={isLoading}
          selectedFiles={selectedFiles}
          selectedTableKeys={selectedTableKeys}
          setSelectedTableKeys={setSelectedTableKeys}
          isFilesListInGridMode={isFilesListInGridMode}
          setIsFilesListInGridMode={setIsFilesListInGridMode}
          onFiltersChange={handleFiltersChange}
          filters={filters}
          handleFileMenuAction={handleFileMenuAction}
          breadcrumbItems={breadcrumbItems}
          filesActions={topBarFileActions}
        />
      </ContentLayout.Header>

      <ContentLayout.Content>
        <FilesOnBehalfOfUserAlert />

        {isFilesListInGridMode ? (
          <FilesList
            files={files}
            isLoading={isLoading}
            handleLoadMore={handleLoadMore}
            selectedTableKeys={selectedTableKeys}
            setSelectedTableKeys={setSelectedTableKeys}
            handleRowClick={handleRowClick}
            handleRowContextMenu={handleRowContextMenu}
            handleRowDoubleClick={handleFileRowDoubleClick}
            handleFileRowClick={handleFileRowClick}
            emptyState={emptyState}
          />
        ) : (
          <FilesTable
            files={files}
            isLoading={isLoading}
            handleLoadMore={handleLoadMore}
            handleFileRowClick={handleFileRowClick}
            handleFileRowDoubleClick={handleFileRowDoubleClick}
            handleRowContextMenu={handleRowContextMenu}
            rowSelection={rowSelection}
            handleTableChange={handleTableChange}
            tableScrollY={tableScrollY}
            selectedTableKeys={selectedTableKeys}
            setSelectedTableKeys={setSelectedTableKeys}
            emptyState={emptyState}
          >
            <Table.Column
              title="Title"
              dataIndex="title"
              defaultSortOrder={'ascend'}
              key="title"
              fixed="left"
              width={200}
              sorter
              render={(_, record: File) => <FilesTableTitleCell file={record} />}
            />

            <Table.Column
              title="Tags"
              dataIndex="tags"
              key="tags"
              width={150}
              render={(_, record: File) => <FilesTableTagsCell file={record} />}
            />

            <Table.Column
              title="File Size"
              dataIndex="fileSize"
              key="fileSize"
              width={150}
              sorter
              render={(_, record: File) => <FilesTableFileSizeCell file={record} />}
            />
            <Table.Column
              title="Deletion Date"
              dataIndex="deletedAt"
              key="deletedAt"
              width={150}
              sorter
              render={(_, record: File) => <FilesTableDeletionDateCell file={record} />}
            />
            <Table.Column
              title=""
              key="actions"
              fixed="right"
              width={1}
              render={(_, record: File) => (
                <FilesTableActionsCell
                  file={record}
                  handleFileMenuAction={handleFileMenuAction}
                  handleRowContextMenu={handleRowContextMenu}
                  filesActions={topBarFileActions}
                  setSelectedTableKeys={setSelectedTableKeys}
                />
              )}
            />
          </FilesTable>
        )}
        <FileContextMenu
          files={selectedFiles}
          isUploadDisabledInCurrentFolder={true}
          position={contextMenuPosition}
          visible={isContextMenuVisible}
          onClose={() => setIsContextMenuVisible(false)}
          onAction={(fileUids, action) => {
            handleFileMenuAction(fileUids, action);
          }}
          filesActions={contextMenuFileActions}
        />
      </ContentLayout.Content>
    </ContentLayout>
  );
};

export default TrashFiles;
